import { useEffect, useState } from 'react';
import { Toaster } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import styled from 'styled-components';
import './App.css';
import Dashboard from './pages/authorized/dashboard/Dashboard';
import Header from './pages/authorized/header/Header';
import Drawer from './pages/authorized/sidebar/Drawer';
import ForgetPassword from './pages/unthorized/forgetPassword/ForgetPassword';
import Login from './pages/unthorized/login/Login';
import { fonts, Layout, RequireAuth } from './utils';
import Posts from './pages/authorized/posts/Posts';
import CompanyProfile from './pages/authorized/companyProfile/CompanyProfile';
import CompanyTabs from './pages/authorized/companyProfile/SideNavigationPages/CompanyTabs';
import PostCategories from './pages/authorized/posts/PostCategories';
import Slider from './pages/authorized/slider/Slider';
import Slides from './pages/authorized/slides/Slides';
import Permissions from './pages/authorized/permissions/Permissions';
import Roles from './pages/authorized/roles/Roles';
import Documents from './pages/authorized/shareholderRights/Documents';
import Videos from './pages/authorized/shareholderRights/Videos';
import Webinars from './pages/authorized/shareholderRights/Webinars';
import Faq from './pages/authorized/shareholderRights/Faqs';
import GovernanceNews from './pages/authorized/posts/Governance News';
import SpecificCompNews from './pages/authorized/posts/Specific Comp News';
import AboutUs from './pages/authorized/about/AboutUs';
import PendingRequests from './pages/authorized/pendingRequests/PendingRequests';
import WebinarsnEvents from './pages/authorized/shareholderEducation/Webinars&Events';
import Courses from './pages/authorized/shareholderEducation/Courses';
import CourseCategories from './pages/authorized/shareholderEducation/CourseCategories';
import Users from './pages/authorized/users/Users';
import EVoting from './pages/authorized/eServices/EVoting';
import Quizzes from './pages/authorized/shareholderEducation/Quizzes';
import Podcasts from './pages/authorized/shareholderEducation/Podcasts';
import Presentations from './pages/authorized/shareholderEducation/Presentations';
import GovernanceUpdates from './pages/authorized/shareholderEducation/GovernanceUpdates';
import Profile from './pages/authorized/profile/Profile';
import PostResources from './pages/authorized/posts/PostResources';
import ComplaintForms from './pages/authorized/complaint forms/ComplaintForms';
import NotFound from './pages/NotFound';

const { primaryFont } = fonts;

const Container = styled.div`
	margin-left: ${(props) => (props.ml ? props.ml : '27.5rem')};
	transition: all 0.3s ease-in-out;
	padding-right: 1rem;

	@media screen and (max-width: 500px) {
		margin-left: ${(props) => (props.ml ? props.ml : '22rem')};
	}
`;

function App() {
	const { isLoggedIn, token } = useSelector((state) => state.activeAccount);
	const dispatch = useDispatch();
	// use Auth call from out custom hooks
	// const { isLoggedIn } = useAuth();
	const [containerWidth, setContainerWidth] = useState(false);

	const routesWidthChange = (data) => {
		setContainerWidth(data);
	};

	useEffect(() => {
		if (!isLoggedIn) {
			setContainerWidth(false);
		}
	}, [dispatch, isLoggedIn, containerWidth]);

	return (
		<div style={{ display: 'flex !important', width: '100vw' }}>
			<Toaster
				position='top-right'
				reverseOrder={false}
				toastOptions={{
					className: '',
					style: {
						fontSize: '1.4rem',
						fontFamily: primaryFont,
						fontWeight: 600,
					},
					duration: 3000,
				}}
			/>
			{isLoggedIn && token && <Drawer routesWidthChange={routesWidthChange} />}
			{/* {isLoggedIn && token && !test && <OldDrawer routesWidthChange={routesWidthChange} />} */}
			<Container ml={!containerWidth && '8rem'}>
				{isLoggedIn && <Header />}

				<Routes>
					<Route path='/' element={<Layout />}>
						{/* public routes */}
						{!isLoggedIn && !token && (
							<>
								<Route path='/login' element={<Login />} />
								<Route path='/forget-password' element={<ForgetPassword/>} />
								{/* <Route path="/register" element={<SignUp />} />
								<Route path="/forgotten-password" element={<ForgotPassword />} />
								<Route path="/forgotten-password/account-recovery" element={<AccountRecovery />} />
								<Route path="/forgotten-password/account-recovery/change-password" element={<ChangePassword />} /> */}
							</>
						)}

						{/* protected routes */}
						<Route element={<RequireAuth />}>
							<>
								<Route path='/' element={<Dashboard />} />
								<Route
									path='/company-details'
									element={<CompanyTabs />}
								/>
								<Route
									path='/company-profile'
									element={<CompanyProfile />}
								/>
								<Route
									path='/profile'
									element={<Profile />}
								/>
								<Route
									path='/about-us'
									element={<AboutUs />}
								/>
								<Route
									path='/pending-requests'
									element={<PendingRequests />}
								/>
								<Route
									path='/complaint-forms'
									element={<ComplaintForms />}
								/>
								<Route
									path='/corporate-governance-library/legal-and-regulatory/posts'
									element={<Posts />}
								/>
								<Route
									path='/corporate-governance-library/information-repository/posts'
									element={<Posts />}
								/>
								<Route
									path='/corporate-governance-library/legal-and-regulatory/categories'
									element={<PostCategories />}
								/>
								<Route
									path='/corporate-governance-library/information-repository/categories'
									element={<PostCategories />}
								/>
								<Route
									path='/corporate-governance-library/legal-and-regulatory/resources'
									element={<PostResources />}
								/>
								<Route
									path='/corporate-governance-library/information-repository/resources'
									element={<PostResources />}
								/>
								<Route
									path='/corporate-governance-library/news/governance-news'
									element={<GovernanceNews />}
								/>
								<Route
									path='/slider'
									element={<Slider />}
								/>
								<Route
									path='/slides/:id'
									element={<Slides />}
								/>
								<Route
									path='/shareholder-rights/documents'
									element={<Documents />}
								/>
								<Route
									path='/shareholder-rights/videos'
									element={<Videos />}
								/>
								<Route
									path='/shareholder-rights/webinars'
									element={<Webinars />}
								/>
								<Route
									path='/shareholder-rights/faqs'
									element={<Faq />}
								/>
								<Route
									path='/shareholder-education/webinars'
									element={<WebinarsnEvents />}
								/>
								<Route
									path='/shareholder-education/courses'
									element={<Courses />}
								/>
								<Route
									path='/shareholder-education/courses-categories'
									element={<CourseCategories />}
								/>
								<Route
									path='/shareholder-education/quizzes'
									element={<Quizzes />}
								/>
								<Route
									path='/shareholder-education/podcasts'
									element={<Podcasts />}
								/>
								<Route
									path='/shareholder-education/presentations'
									element={<Presentations />}
								/>
								<Route
									path='/shareholder-education/governance-updates'
									element={<GovernanceUpdates />}
								/>
								<Route
									path='/e-service/e-voting'
									element={<EVoting />}
								/>
								<Route
									path='/permissions'
									element={<Permissions />}
								/>
								<Route
									path='/roles'
									element={<Roles />}
								/>
								<Route
									path='/users'
									element={<Users />}
								/>
								
								
							
								{/* main menu */}
								{/* <Route path='/menu/listing' element={<MenuList />} />
								<Route path='/menu/add' element={<MenuAdd />} />
								<Route path='/menu/edit' element={<MenuEdit />} />
								<Route path='/menu/submenu/add' element={<SubMenuAdd />} />
								<Route path='/menu/submenu/edit' element={<SubMenuEdit />} />
								<Route path='/menu/role-assign' element={<SubMenuMap />} />
								<Route
									path='/menu/role-assign/role-manage'
									element={<SubMenuAccess />}
								/> */}
							
								{/* Components */}
								{/* <Route path='/components/test' element={<TableComp />} />
								<Route path='/components/toaster' element={<ToasterDemo />} />
								<Route path='/change-password/change' element={<ChangePass />} />
								<Route path='/external-pages/newapp' element={<NewApp />} /> */}
							</>
						</Route>

						<Route path='/not-found' element={<NotFound />} />
						{/* catch all */}
						<Route
							path='*'
							element={<Navigate to={isLoggedIn && token ? '/' : '/login'} />}
						/>
					</Route>
				</Routes>
			</Container>
		</div>
	);
}

export default App;
